/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonaGroupResponse } from './PersonaGroupResponse';
import {
    PersonaGroupResponseFromJSON,
    PersonaGroupResponseFromJSONTyped,
    PersonaGroupResponseToJSON,
    PersonaGroupResponseToJSONTyped,
} from './PersonaGroupResponse';

/**
 * 
 * @export
 * @interface ExperimentDetailResponse
 */
export interface ExperimentDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof ExperimentDetailResponse
     */
    experimentId: number;
    /**
     * 
     * @type {string}
     * @memberof ExperimentDetailResponse
     */
    experimentName: string;
    /**
     * 
     * @type {Date}
     * @memberof ExperimentDetailResponse
     */
    experimentStartTime?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ExperimentDetailResponse
     */
    experimentEndTime?: Date | null;
    /**
     * 
     * @type {Array<PersonaGroupResponse>}
     * @memberof ExperimentDetailResponse
     */
    groups: Array<PersonaGroupResponse>;
}

/**
 * Check if a given object implements the ExperimentDetailResponse interface.
 */
export function instanceOfExperimentDetailResponse(value: object): value is ExperimentDetailResponse {
    if (!('experimentId' in value) || value['experimentId'] === undefined) return false;
    if (!('experimentName' in value) || value['experimentName'] === undefined) return false;
    if (!('groups' in value) || value['groups'] === undefined) return false;
    return true;
}

export function ExperimentDetailResponseFromJSON(json: any): ExperimentDetailResponse {
    return ExperimentDetailResponseFromJSONTyped(json, false);
}

export function ExperimentDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExperimentDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'experimentId': json['experiment_id'],
        'experimentName': json['experiment_name'],
        'experimentStartTime': json['experiment_start_time'] == null ? undefined : (new Date(json['experiment_start_time'])),
        'experimentEndTime': json['experiment_end_time'] == null ? undefined : (new Date(json['experiment_end_time'])),
        'groups': ((json['groups'] as Array<any>).map(PersonaGroupResponseFromJSON)),
    };
}

export function ExperimentDetailResponseToJSON(json: any): ExperimentDetailResponse {
    return ExperimentDetailResponseToJSONTyped(json, false);
}

export function ExperimentDetailResponseToJSONTyped(value?: ExperimentDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'experiment_id': value['experimentId'],
        'experiment_name': value['experimentName'],
        'experiment_start_time': value['experimentStartTime'] == null ? value['experimentStartTime'] : value['experimentStartTime'].toISOString(),
        'experiment_end_time': value['experimentEndTime'] == null ? value['experimentEndTime'] : value['experimentEndTime'].toISOString(),
        'groups': ((value['groups'] as Array<any>).map(PersonaGroupResponseToJSON)),
    };
}

